import React, { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function AccommodationTypeCheckboxList({ items, onChange, title }) {
    // Initialize checkedItems state
    const [checkedItems, setCheckedItems] = useState({});

    useEffect(() => {
        if (items) {
            const initialCheckedState = items.reduce((acc, item) => {
                acc[item.accommodationTypeName] = true; // Initialize all items as checked by default
                return acc;
            }, {});
            setCheckedItems(initialCheckedState);
        }
    }, [items]); // Depend on items so this effect runs whenever items change

    const handleCheckboxChange = (event, accommodationTypeName) => {
        const selectedCount = Object.values(checkedItems).filter(checked => checked).length;

        if (selectedCount === 1 && !event.target.checked) {
            return;
        }

        setCheckedItems(prev => ({
            ...prev,
            [accommodationTypeName]: event.target.checked
        }));
    };

    useEffect(() => {
        if (items) {
            onChange(Object.keys(checkedItems).filter(key => checkedItems[key]));
        }
    }, [checkedItems, items]); // Only depend on checkedItems and items

    return (
        <FormGroup>
            <div className="refiner-heading">{title}</div>
            {items && items.length > 0 ? items.map((item) => {
                const selectedCount = Object.values(checkedItems).filter(checked => checked).length;
                const isLastSelected = selectedCount === 1 && checkedItems[item.accommodationTypeName];

                return (
                    <FormControlLabel
                        key={item.accommodationTypeName}
                        control={
                            <Checkbox
                                checked={checkedItems[item.accommodationTypeName] ?? false}
                                onChange={(event) => handleCheckboxChange(event, item.accommodationTypeName)}
                                disabled={isLastSelected}
                            />
                        }
                        label={
                            <span style={isLastSelected ? { color: 'grey' } : {}}>
                                {item.accommodationTypeName}
                            </span>
                        }
                    />
                );
            }) : <div>No items to display.</div>}
        </FormGroup>
    );
}

export default AccommodationTypeCheckboxList;
